<template>
  <div class="text-center">
    <fa-icon
      v-if="canEdit"
      icon="edit"
      class="table-action-icon mr-1"
      @click="editItem"
    />
    <fa-icon
      v-if="canDelete && !params.data.deleted"
      icon="trash-alt"
      class="table-action-icon mr-1"
      @click="removeItem"
    />
    <fa-icon
      icon="print"
      class="table-action-icon accent"
      @click="openPrint"
    />
  </div>
</template>

<script>
import store from '@/store'
import itfModule from '@/store/itf/itf'

const ADMIN_EDIT_EMAILS = ['ruben.ordanyan@gmail.com', 'khamazaspyan@gmail.com']

export default {
  name: 'cell-renderer-itf-actions',
  created() {
    if (!store.hasModule('itfModule')) {
      store.registerModule('itfModule', itfModule)
    }
  },
  computed: {
    user() {
      return this.$store.state.user || {}
    },
    userType() {
      try {
        return atob(this.$store.state.user_type)
      } catch (e) {
        return null
      }
    },
    isAdminEditor() {
      return this.userType === 'ADMIN' && ADMIN_EDIT_EMAILS.includes(this.user.email)
    },
    canEdit() {
      return this.isAdminEditor
    },
    canDelete() {
      return this.isAdminEditor
    },
  },
  methods: {
    editItem() {
      this.$store.commit('itfModule/OPEN_EDIT_FORM', this.params.data)
    },
    openPrint() {
      this.$store.commit('itfModule/SET_SELECTED_ITF', this.params.data)
      this.$store.commit('itfModule/OPEN_DOC', 'print')
    },
    removeItem() {
      this.$swal({
        title: 'Հեռացնե՞լ',
        text: '',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Այո',
        cancelButtonText: 'Ոչ',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (!result.value) return

        this.$store.dispatch('itfModule/deleteAdminItf', this.params.data)
          .catch(() => {
            this.$swal({
              title: 'Գործողությունը մերժվել է',
              text: 'Ստուգեք Ձեր ինտերնետ կապի առկայությունը!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          })
      })
    },
  },
}
</script>
